<template>
<section>

    <div class="toc">
      <div class="columns is-centered has-text-centered is-mobile">
        <div class="column is-narrow">
          <p>Jump to:</p>
        </div>
        <div class="column is-narrow" v-if="slot1text && slot1link">
          <a :href="'#' + slot1link">{{slot1text}}</a>
        </div>
        <div class="column is-narrow" v-if="slot2text && slot2link">
          <a :href="'#' + slot2link">{{slot2text}}</a>
        </div>
        <div class="column is-narrow" v-if="slot3text && slot3link">
          <a :href="'#' + slot3link">{{slot3text}}</a>
        </div>
      </div>


    </div>
  </section>
</template>

<script>
export default {
  name: 'TOC',
  props: ['slot1text', 'slot1link', 'slot2text', 'slot2link', 'slot3text', 'slot3link'],
  data () {
    return {

  }
  },
  methods: {
   
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .toc {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
  .toc a {
      font-weight:bold;
    }
  @media screen and (max-width: 768px) {
    .toc .column {
      padding: 15px 7px;
    }
    
  }
</style>


// WEBPACK FOOTER //
// src/components/TOC.vue